<template>
  <Modal ref="modal">
    <h2 class="box__title">{{ $t('createWorkspaceModal.createNew') }}</h2>
    <Error :error="error"></Error>
    <WorkspaceForm
      ref="workspaceForm"
      :default-name="getDefaultName()"
      @submitted="submitted"
    >
      <div class="actions">
        <div class="align-right">
          <Button
            type="primary"
            size="large"
            :loading="loading"
            :disabled="loading"
          >
            {{ $t('createWorkspaceModal.add') }}
          </Button>
        </div>
      </div>
    </WorkspaceForm>
  </Modal>
</template>

<script>
import modal from '@onedesk/modules/core/mixins/modal'
import error from '@onedesk/modules/core/mixins/error'
import { getNextAvailableNameInSequence } from '@onedesk/modules/core/utils/string'

import WorkspaceForm from './WorkspaceForm'
import { ResponseErrorMessage } from '@onedesk/modules/core/plugins/clientHandler'
import { pageFinished } from '@onedesk/modules/core/utils/routing'
import { nextTick, useNuxtApp } from '#imports'

export default {
  name: 'CreateWorkspaceModal',
  components: { WorkspaceForm },
  mixins: [modal, error],
  emits: ['created'],
  setup() {
    const nuxtApp = useNuxtApp()
    return { nuxtApp }
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    getDefaultName() {
      const excludeNames = this.$store.getters['workspace/getAll'].map(
        (workspace) => workspace.name
      )
      const baseName = this.$t('createWorkspaceModal.defaultName')
      return getNextAvailableNameInSequence(baseName, excludeNames)
    },
    async submitted(values) {
      this.loading = true
      this.hideError()

      try {
        const workspace = await this.$store.dispatch('workspace/create', values)
        await this.$store.dispatch('workspace/select', workspace)
        this.loading = false
        this.$emit('created', workspace)
        await this.$router.push({
          name: 'workspace',
          params: { workspaceId: workspace.id },
        })
        await pageFinished(this.nuxtApp)
        await nextTick()
        this.$emit('created')
        this.hide()
      } catch (error) {
        this.loading = false
        this.handleError(error, 'workspace')
        this.handleError(error, 'workspace', {
          PERMISSION_DENIED: new ResponseErrorMessage(
            this.$t('createWorkspaceModal.permissionDeniedTitle'),
            this.$t('createWorkspaceModal.permissionDeniedBody')
          ),
        })
      }
    },
  },
}
</script>
